<template>
  <div>
    <Head :title="__(title)" />
    <div class="mb-6 flex justify-between items-center">
      <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
      <Link class="btn-indigo" :href="this.route('incoming_goods.create')">
        <span>{{ __('Create a New Data') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">#{{ __('ID') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Transaction Code') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Date') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Action') }}</th>
        </tr>
        <tr v-for="item in data_incoming_goods.data" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6 py-4 flex items-center focus:text-indigo-500">
            {{ item.id }}
          </td>
          <td class="border-t px-6 py-4 items-center focus:text-indigo-500">
            {{ item.transaction_code }}
          </td>
          <td class="border-t px-6 py-4 items-center focus:text-indigo-500">
            {{ formatDate(item.created_at, 'YYYY-MM-DD') }}
          </td>
          <td class="border-t px-6 py-4">
            <div class="flex justify-start space-x-4">
              <Link class="text-indigo-600 hover:text-indigo-900" :href="this.route('incoming_goods.edit', item.id)" tabindex="-1">
                <icon name="edit" class="block w-5 h-5" />
              </Link>
              <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy(item.id)">
                <icon name="trash" class="block w-5 h-5" />
              </button>
              <Link class="text-green-600 hover:text-green-900" :href="this.route('incoming_goods.show', item.id)" tabindex="-1">
                <icon name="eye" class="block w-5 h-5" />
              </Link>
            </div>
          </td>
        </tr>
        <tr v-if="data_incoming_goods.data.length === 0">
          <td class="border-t px-6 py-4" colspan="6">No data found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="data_incoming_goods.links" />
  </div>
</template>

      <script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { formatDate } from '@/utils/dateFormatter.js'

export default {
  metaInfo: { title: 'Incoming Goods' },
  components: {
    Icon,
    Link,
    Head,
    Pagination,
    SearchInput,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    data_incoming_goods: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('incoming_goods'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(id) {
      if (confirm('Are you sure you want to delete this data?')) {
        this.$inertia.delete(this.route('incoming_goods.destroy', id))
      }
    },
    formatDate(dateString, format) {
      return formatDate(dateString, format)
    },
  },
}
</script>
